import { Component, OnInit } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

@Component({
    templateUrl: './logout.component.html',
    standalone: true
})
export class LogoutComponent implements OnInit {
  token: string;

  constructor(private oauthService: OAuthService) {
    // this.token = this.oauthService.getAccessToken();
    this.oauthService.logOut();
  }

  ngOnInit() {
  }
}
